"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emotesWorldMenu = void 0;
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const Emote_1 = require("../classes/Emote");
const WorldMenu_1 = require("../classes/WorldMenu");
const state_1 = require("../state");
const createImage_1 = require("../functions/ui/components/createImage");
const createPanel_1 = require("../functions/ui/components/createPanel");
const createSlot_1 = require("../functions/ui/components/createSlot");
const constants_1 = require("../constants");
const getCyclicIndex_1 = require("../functions/getCyclicIndex");
const definables_1 = require("definables");
const getWorldState_1 = require("../functions/state/getWorldState");
const isWorldCombatInProgress_1 = require("../functions/isWorldCombatInProgress");
const useEmote_1 = require("../functions/useEmote");
var EmotesTab;
(function (EmotesTab) {
    EmotesTab["Free"] = "free";
    EmotesTab["Subscriber"] = "subscriber";
})(EmotesTab || (EmotesTab = {}));
exports.emotesWorldMenu = new WorldMenu_1.WorldMenu({
    create: () => {
        const hudElementReferences = [];
        const buttonIDs = [];
        const labelIDs = [];
        const spriteIDs = [];
        const freeTabCondition = () => exports.emotesWorldMenu.state.values.tab === EmotesTab.Free;
        const subscriberTabCondition = () => exports.emotesWorldMenu.state.values.tab === EmotesTab.Subscriber;
        // Background panel
        hudElementReferences.push((0, createPanel_1.createPanel)({
            condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
            height: 184,
            imagePath: "panels/basic",
            width: 128,
            x: 176,
            y: 24,
        }));
        // Tabs
        spriteIDs.push((0, pixel_pigeon_1.createSprite)({
            animationID: () => {
                switch (exports.emotesWorldMenu.state.values.tab) {
                    case EmotesTab.Free:
                        return "1";
                    case EmotesTab.Subscriber:
                        return "2";
                }
            },
            animations: [
                {
                    frames: [
                        {
                            height: 21,
                            sourceHeight: 21,
                            sourceWidth: 124,
                            sourceX: 0,
                            sourceY: 0,
                            width: 124,
                        },
                    ],
                    id: "1",
                },
                {
                    frames: [
                        {
                            height: 21,
                            sourceHeight: 21,
                            sourceWidth: 124,
                            sourceX: 124,
                            sourceY: 0,
                            width: 124,
                        },
                    ],
                    id: "2",
                },
            ],
            coordinates: {
                condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                x: 178,
                y: 26,
            },
            imagePath: "tabs/2",
        }));
        hudElementReferences.push((0, createImage_1.createImage)({
            condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
            height: 16,
            imagePath: "tab-icons/emotes/free",
            width: 16,
            x: 197,
            y: 29,
        }));
        hudElementReferences.push((0, createImage_1.createImage)({
            condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
            height: 16,
            imagePath: "tab-icons/emotes/subscriber",
            width: 16,
            x: 250,
            y: 29,
        }));
        buttonIDs.push((0, pixel_pigeon_1.createButton)({
            coordinates: {
                condition: () => subscriberTabCondition() && (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                x: 179,
                y: 27,
            },
            height: 20,
            onClick: () => {
                exports.emotesWorldMenu.state.setValues({
                    tab: EmotesTab.Free,
                });
            },
            width: 52,
        }));
        buttonIDs.push((0, pixel_pigeon_1.createButton)({
            coordinates: {
                condition: () => freeTabCondition() && (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                x: 232,
                y: 27,
            },
            height: 20,
            onClick: () => {
                exports.emotesWorldMenu.state.setValues({
                    tab: EmotesTab.Subscriber,
                });
            },
            width: 51,
        }));
        // X button
        hudElementReferences.push((0, createImage_1.createImage)({
            condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
            height: 11,
            imagePath: "x",
            onClick: () => {
                exports.emotesWorldMenu.close();
            },
            width: 10,
            x: 287,
            y: 31,
        }));
        const getEmotes = () => {
            const emotes = [];
            for (const emote of (0, definables_1.getDefinables)(Emote_1.Emote).values()) {
                switch (exports.emotesWorldMenu.state.values.tab) {
                    case EmotesTab.Free:
                        if (emote.requiresSubscription === false) {
                            emotes.push(emote);
                        }
                        break;
                    case EmotesTab.Subscriber:
                        if (emote.requiresSubscription) {
                            emotes.push(emote);
                        }
                        break;
                }
            }
            return emotes;
        };
        const getPage = () => {
            switch (exports.emotesWorldMenu.state.values.tab) {
                case EmotesTab.Free:
                    return exports.emotesWorldMenu.state.values.freePage;
                case EmotesTab.Subscriber:
                    return exports.emotesWorldMenu.state.values.subscriberPage;
            }
        };
        const setPage = (page) => {
            switch (exports.emotesWorldMenu.state.values.tab) {
                case EmotesTab.Free:
                    exports.emotesWorldMenu.state.setValues({
                        freePage: page,
                    });
                    break;
                case EmotesTab.Subscriber:
                    exports.emotesWorldMenu.state.setValues({
                        subscriberPage: page,
                    });
                    break;
            }
        };
        for (let i = 0; i < constants_1.emotesPerPage; i++) {
            const getEmote = () => {
                const page = getPage();
                const order = i + page * constants_1.emotesPerPage;
                return getEmotes().find((emote) => emote.order === order);
            };
            hudElementReferences.push((0, createSlot_1.createSlot)({
                button: {
                    onClick: () => {
                        const worldState = (0, getWorldState_1.getWorldState)();
                        const emote = getEmote();
                        if (typeof emote === "undefined") {
                            throw new Error("Emote is undefined.");
                        }
                        if (emote.requiresSubscription === false ||
                            state_1.state.values.isSubscribed) {
                            exports.emotesWorldMenu.close();
                            (0, useEmote_1.useEmote)(emote.id);
                            worldState.setValues({
                                lastUsedEmoteID: emote.id,
                            });
                        }
                        else {
                            (0, pixel_pigeon_1.postWindowMessage)({ event: "subscribe/emote" });
                        }
                    },
                },
                condition: () => typeof getEmote() !== "undefined" &&
                    (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                icons: [
                    {
                        imagePath: () => {
                            const emote = getEmote();
                            if (typeof emote === "undefined") {
                                throw new Error("Emote is undefined.");
                            }
                            return emote.backgroundImagePath;
                        },
                    },
                    {
                        condition: () => {
                            const emote = getEmote();
                            if (typeof emote === "undefined") {
                                throw new Error("Emote is undefined.");
                            }
                            return (emote.hasForegroundImagePath() &&
                                (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false);
                        },
                        imagePath: () => {
                            const emote = getEmote();
                            if (typeof emote === "undefined") {
                                throw new Error("Emote is undefined.");
                            }
                            return emote.foregroundImagePath;
                        },
                    },
                ],
                imagePath: "slots/basic",
                x: 184 + 24 * (i % 5),
                y: 54 + 24 * Math.floor(i / 5),
            }));
        }
        const isPaginated = () => getEmotes().length > constants_1.emotesPerPage;
        const getLastPage = () => Math.max(Math.floor((getEmotes().length - 1) / constants_1.emotesPerPage), 0);
        const page = (offset) => {
            const pages = [];
            for (let i = 0; i < getLastPage() + 1; i++) {
                pages.push(i);
            }
            setPage((0, getCyclicIndex_1.getCyclicIndex)(pages.indexOf(getPage()) + offset, pages));
        };
        // Page left arrow
        hudElementReferences.push((0, createImage_1.createImage)({
            condition: () => isPaginated() && (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
            height: 14,
            imagePath: "arrows/left",
            onClick: () => {
                page(-1);
            },
            width: 14,
            x: 190,
            y: 176,
        }));
        // Page right arrow
        hudElementReferences.push((0, createImage_1.createImage)({
            condition: () => isPaginated() && (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
            height: 14,
            imagePath: "arrows/right",
            onClick: () => {
                page(1);
            },
            width: 14,
            x: 275,
            y: 176,
        }));
        // Page number
        labelIDs.push((0, pixel_pigeon_1.createLabel)({
            color: retrommo_types_1.Color.White,
            coordinates: {
                condition: () => isPaginated() && (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                x: 296,
                y: 193,
            },
            horizontalAlignment: "right",
            text: () => ({
                value: String(getPage() + 1),
            }),
        }));
        return (0, pixel_pigeon_1.mergeHUDElementReferences)([
            {
                buttonIDs,
                labelIDs,
                spriteIDs,
            },
            ...hudElementReferences,
        ]);
    },
    initialStateValues: {
        freePage: 0,
        subscriberPage: 0,
        tab: EmotesTab.Free,
    },
    preventsWalking: false,
});
